import { render, staticRenderFns } from "./xueyang.vue?vue&type=template&id=0333c070&scoped=true&"
import script from "./xueyang.vue?vue&type=script&lang=ts&"
export * from "./xueyang.vue?vue&type=script&lang=ts&"
import style0 from "./xueyang.vue?vue&type=style&index=0&id=0333c070&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0333c070",
  null
  
)

export default component.exports